<template>
  <!-- persistent só depois de carregado: enquanto carrega não há botão de fechar,
       e uma janela persistente com a requisição travada prenderia o usuário. -->
  <ontos-dialog :model-value="true" :fullscreen="$vuetify.display.smAndDown" :max-width="maxWidth"
            :persistent="loaded" @update:model-value="onDialogInput">
    <!-- Direto dentro do diálogo, sem div em volta: o overlay de "salvando" que o painel traz
         se posiciona contra o ancestral posicionado mais próximo, e uma div viraria esse
         ancestral. O porquê está no próprio painel. -->
    <ontos-form-panel :title="title" :subtitle="subtitle" :accent="accent"
                      :loaded="loaded" :saving="saving" :save-disabled="saveDisabled"
                      @save="$emit('save')">
      <template #controls>
        <ontos-dialog-actions :full-page-route="fullPageRoute" :dirty="dirty"
                              :disabled="saving" @closed="$emit('closed')"/>
      </template>
      <slot/>
    </ontos-form-panel>
  </ontos-dialog>
</template>
<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'
import FormPanel from '@/components/shared/FormPanel.vue'
import {RouteLocationRaw} from 'vue-router'

/**
 * Casca dos modais de formulário: a JANELA em volta do painel de formulário, com o X e o
 * atalho para a página inteira no cabeçalho dele.
 *
 * O miolo — cabeçalho, conteúdo e o botão Salvar — mora no `FormPanel`, porque há janela que
 * mostra um formulário sem ser uma janela nova: a da instância troca entre ver e editar dentro
 * do mesmo diálogo. Aqui ficou só o que é da janela.
 *
 * Fecha só pelo X — não há Cancelar, e depois de carregado nem ESC nem clique fora
 * descartam o que foi digitado. Antes cada diálogo repetia essa casca inteira e o
 * padrão foi se soltando de um para o outro.
 *
 * Quem valida e grava é o host: daqui sai só o evento save.
 */
@Component({emits: ['closed', 'save'],
  name: 'ontos-form-dialog',
  components: {'ontos-form-panel': FormPanel}
})
class FormDialog extends Vue {
  @Prop({type: String, default: ''}) readonly title!: string
  @Prop({type: String, default: ''}) readonly subtitle!: string
  /** Repassado ao cabeçalho: é o `heading` inteiro que chega por `v-bind` de quem abre. */
  @Prop({type: String, default: ''}) readonly accent!: string
  @Prop({type: [String, Number], default: '960px'}) readonly maxWidth!: string | number
  /** Enquanto false, mostra o indicador de carga no lugar do formulário */
  @Prop({type: Boolean, default: true}) readonly loaded!: boolean
  @Prop({type: Boolean, default: false}) readonly saving!: boolean
  @Prop({type: Boolean, default: false}) readonly saveDisabled!: boolean
  /** Destino do "abrir em página inteira". Sem ele, o atalho não aparece. */
  @Prop({type: Object, default: null}) readonly fullPageRoute!: RouteLocationRaw | null
  /** Há rascunho: fechar ou sair para a página inteira passa a pedir confirmação */
  @Prop({type: Boolean, default: false}) readonly dirty!: boolean

  /**
   * Só dispara enquanto carrega: depois de carregado o persistent bloqueia ESC e
   * clique fora, então o evento nem chega. Sem isto o :value fixo em true manteria
   * a janela aberta, e durante a carga não há botão de fechar.
   */
  onDialogInput(open: boolean) {
    if (!open && !this.loaded) this.$emit('closed')
  }
}

export default toNative(FormDialog)
</script>
